import { SimpleGrid } from "@chakra-ui/react";
import React from "react";

function Login() {
  return (
    <SimpleGrid columns={[1, 1, 3]} spacing="40px">
      signup
    </SimpleGrid>
  );
}

export default Login;
